/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
export default class FuiCheckboxComponent extends Component {
  get settings() {
    const settings = this.args.settings || {};
    if (!this.onChange) return settings;
    return Object.assign({}, this.args.settings, {
      onChange: this.onChange
    });
  }
  get onChange() {
    if (!this.args.settings) return undefined;
    const initialOnChange = this.args.settings.onChange;
    if (!initialOnChange) return undefined;

    // FUI checkbox module calls the onChange callback with `settings.onChange.call(input)`
    // https://github.com/fomantic/Fomantic-UI/blob/910440f6275a7e85e278915dfb4846c88d43f1ba/src/definitions/modules/checkbox.js#L187
    // The callback will not receive any argument, but the context (ie: this), will be the HTMLInputElement
    // and we will get the checked info with `this.checked`
    return function () {
      initialOnChange(this.checked);
    };
  }
  get class() {
    if (!this.args.type) return "ui checkbox";
    return this.args.type === "checkbox" ? "ui checkbox" : `ui ${this.args.type} checkbox`;
  }
  get type() {
    return this.args.type === "radio" ? "radio" : "checkbox";
  }
}